import { render, staticRenderFns } from "./TreatyHeader.vue?vue&type=template&id=7fa2d096&"
import script from "./TreatyHeader.vue?vue&type=script&lang=js&"
export * from "./TreatyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports